import { API_BASE_URL, API_PATHS, getApiPaths } from "../utils/constants/api.constants";
import axiosInstance from "../utils/authUtils";


class ResultService {

    static getResult(item = {}) {
        const params = new URLSearchParams();

        params.append("limit", item?.limit || 25);
        params.append("page", item?.page || 1);

        if (item?.examId) {
            params.append("examId", item.examId);
        }

        if (item?.studentId) {
            params.append("studentId", item.studentId);
        }

        if (item?.session) {
            params.append("session", item.session);
        }

        const api = `${API_BASE_URL}${API_PATHS.getResult}?${params.toString()}`;

        return axiosInstance.get(api);
    }


    static generateReportCard(item = {}) {

        const params = new URLSearchParams();

        if (item?.examId) {
            params.append("examId", item.examId);
        }

        if (item?.studentId) {
            params.append("studentId", item.studentId);
        }

        if (item?.session) {
            params.append("session", item.session);
        }

        if (item?.standardId) {
            params.append("standardId", item.standardId);
        }

        if (item?.sectionId) {
            params.append("sectionId", item.sectionId);
        }

        const api =
            `${API_BASE_URL}${API_PATHS.generateReportCard}?${params.toString()}`;

        return axiosInstance.get(api);

    }



    static addResult(data) {
        return axiosInstance.post(
            `${API_BASE_URL}${API_PATHS.addResult}`,
            data,
            { headers: { "Content-Type": "application/json" } }
        );
    }



}

export default ResultService;
